// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationMobileBankIdPath = 'M83 89.5c0 5.799-4.701 10.5-10.5 10.5h-45C21.701 100 17 95.299 17 89.5v-79C17 4.701 21.701 0 27.5 0h45C78.299 0 83 4.701 83 10.5v79zM27.5 7a3.5 3.5 0 00-3.5 3.5v79a3.5 3.5 0 003.5 3.5h45a3.5 3.5 0 003.5-3.5v-79A3.5 3.5 0 0072.5 7H61l-4.6 6H43.6L39 7H27.5zM50 89a5 5 0 100-10 5 5 0 000 10zM39.83 46.622A13.952 13.952 0 0136 37c0-7.732 6.268-14 14-14s14 6.268 14 14c0 3.727-1.456 7.114-3.83 9.622C66.627 50.204 71 57.092 71 65h-7c0-7.732-6.268-14-14-14s-14 6.268-14 14h-7c0-7.909 4.372-14.796 10.83-18.378zM50 44a7 7 0 100-14 7 7 0 000 14z';
var IllustrationMobileBankId = baseIllustration('IllustrationMobileBankId', {
  getPath: () => IllustrationMobileBankIdPath
}, 'ColoredIllustrationMobileBankID');
IllustrationMobileBankId.displayName = 'IllustrationMobileBankID';

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationMobileBankId;
//# sourceMappingURL=index.js.map